// extracted by mini-css-extract-plugin
module.exports = {"page":"_2stnL-twel1FI64LnF89At"};